export default [{
  path: '/',
  name: 'home',
  // component: () => import('@/app/dashboard/Dashboard.vue'),
  meta: {
    action: 'auditar',
    requiredAuth: true,
  },

}]
